var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAgendaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99872 21.0036H5.99747C4.33992 21.0036 2.99622 19.6599 2.99622 18.0023V5.99734C2.99622 4.3398 4.33992 2.99609 5.99747 2.99609H17.002C18.6596 2.99609 20.0033 4.3398 20.0033 5.99734V8.99859",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.559 22.003H15.0536C14.3846 22.003 13.7598 21.6687 13.3888 21.112L11.261 17.9199C10.8495 17.3026 10.9309 16.4807 11.4555 15.956V15.956C11.7474 15.6641 12.1433 15.5002 12.5561 15.5002C12.9689 15.5002 13.3648 15.6641 13.6567 15.956L14.501 16.8004V11.4987C14.501 11.1007 14.6591 10.719 14.9405 10.4376C15.222 10.1561 15.6037 9.99805 16.0017 9.99805V9.99805C16.8304 9.99805 17.5023 10.6699 17.5023 11.4987V14.0128L20.3252 14.4732C21.3871 14.6464 22.1219 15.6283 21.9885 16.696L21.5444 20.2503C21.4192 21.2516 20.5681 22.003 19.559 22.003Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99874 9.99734V6.99609",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4994 8.49826H7.49811",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99792 13.0002H9.99917",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99792 16.0002H7.99834",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendaIcon);
export default __webpack_public_path__ + "static/media/agendaIcon.a9894b41de32ea78f0c9e930cab1dfed.svg";
export { ForwardRef as ReactComponent };